import React from "react";
import Screen from "../uizard/ui/Screen";

export default function Terms() {
  return (
    <Screen>
      <StyleTag />
      <div className="legal-wrap">
        <header className="legal-header">
          <h1 className="h1">Terms of Service</h1>
          <p className="lead">Effective Date: September 5, 2025</p>
          <p className="entity">
            Entity: <b>ArtiBytes</b> (“ArtiBytes,” “we,” “us,” “our”)
          </p>
          <p className="intro">
            By using ArtiBytes, you agree to these Terms and our{" "}
            <a href="/privacy">Privacy Policy</a> and{" "}
            <a href="/content-policy">Content Policy</a>.
          </p>
        </header>

        <section className="legal-section">
          <h2 className="h2">1) Service Overview &amp; Accounts</h2>
          <p>
            ArtiBytes provides AI-powered image generation and a Creator program for
            training and hosting Styles. You must provide accurate information and keep
            your account secure. We may refuse, suspend, or terminate access for policy,
            safety, or legal reasons.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="h2">2) Acceptable Use</h2>
          <p>You may not use ArtiBytes to:</p>
          <ul>
            <li>Violate laws or third-party rights (including IP, privacy, publicity).</li>
            <li>Upload illegal, harmful, deceptive, or exploitative content.</li>
            <li>Attempt to reverse engineer, misuse, or attack our services.</li>
            <li>Circumvent usage limits, fees, or safety systems.</li>
          </ul>
          <p>We may enforce limits and take action to ensure safety and compliance.</p>
        </section>

        <section className="legal-section">
          <h2 className="h2">3) User Content &amp; Generated Outputs</h2>

          <p>
            <b>Your uploads (User Content):</b> You retain ownership of your User Content.
            You grant ArtiBytes a non-exclusive, worldwide, sublicensable, transferable
            license to host, store, process, reproduce, and display your User Content only
            as necessary to provide the service, enforce policies, maintain security, and
            comply with law.
          </p>

          <p>
            <b>Generated outputs (your images):</b> Subject to these Terms and applicable
            law, <b>you own the images you generate</b> (to the extent permitted). ArtiBytes
            grants you a <b>non-exclusive, worldwide, royalty-free</b> right to use,
            reproduce, display, distribute, and commercially exploit your outputs.
          </p>

          <p>
            <b>Creator Styles and output rights:</b> If you generate using a Creator Style,
            you still may use your outputs commercially under these Terms. <b>Creators do
            not own or control your outputs</b> solely because you used their Style, and
            Creators agree not to assert claims against users for lawful use of outputs
            generated through ArtiBytes in compliance with these Terms.
          </p>

          <p>
            <b>Styles, models, and artifacts:</b> ArtiBytes (not the Creator) owns the
            platform, model serving systems, and trained Style artifacts (e.g., weights,
            configurations, and serving infrastructure), excluding a Creator’s original
            uploaded assets.
          </p>

          <p>
  <b>Image disputes.</b> If you believe a generated image materially fails to meet the
  described characteristics of a Style or was generated due to a technical error, you may
  submit a dispute through the ArtiBytes interface within a reasonable time after
  generation. Disputes are reviewed in-platform and may be resolved by a credit refund.
  <b>Cash refunds are not provided for image disputes.</b> ArtiBytes may limit dispute
  privileges in cases of abuse and retains final authority over dispute outcomes. See the
  Creator Commercial Licensing Agreement for additional details.
</p>

        </section>

        <section className="legal-section">
          <h2 className="h2">4) Intellectual Property; ArtiBytes Materials</h2>
          <p>
            ArtiBytes and its licensors own all rights in the platform, models, trained
            weights, templates, and documentation (collectively, “ArtiBytes Materials”).
            Except for the rights expressly granted to you here, no other rights are granted
            or implied.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="h2">5) Credits, Payments &amp; Refunds</h2>
<ul>
  <li>Credits are purchased using supported payment methods displayed in-app.</li>

            <li>All purchases are final once a generation is successfully delivered.</li>
            <li>
              If a technical error prevents delivery, contact support within 7 days; we may
              re-deliver or credit/adjust at our discretion.
            </li>
            <li>
              You are responsible for accurate wallet details. We are not liable for
              on-chain/network failures outside our control.
            </li>
          </ul>
        </section>

        <section className="legal-section">
          <h2 className="h2">6) Creator Program (Summary)</h2>
          <p>
            If you submit a style pack, the ArtiBytes Creator Commercial Licensing Agreement
            applies. You must own or control all rights to your uploads. ArtiBytes may
            review, approve, suspend, or remove Styles for policy or safety reasons.
            Royalties accrue on eligible paid generations; payouts occur to your Pi wallet
            when thresholds are met and subject to program terms.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="h2">7) Content Policy &amp; Reporting</h2>
          <p>
            Use must comply with our Content Policy (no infringing, explicit, violent, or
            sensitive content; no illegal use). You can report concerns in-app or by email.
            We may remove content or restrict features at our discretion.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="h2">8) Disclaimers</h2>
          <p>
            The service is provided “as is” and “as available.” We disclaim all warranties,
            express or implied, including merchantability, fitness for a particular purpose,
            and non-infringement. We do not guarantee uninterrupted or error-free operation,
            specific creative results, or that outputs will be unique or free from claims by
            others.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="h2">9) Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, ArtiBytes’ aggregate liability arising
            out of or relating to the service is limited to the greater of (i) €50 or (ii)
            the total fees you paid to ArtiBytes in the 12 months before the event giving
            rise to liability. We are not liable for indirect, incidental, special,
            consequential, or punitive damages, or lost profits/revenue, even if advised of
            the possibility.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="h2">10) Indemnity</h2>
          <p>
            You will defend, indemnify, and hold harmless ArtiBytes and its personnel from
            any claims, damages, liabilities, and costs (including reasonable legal fees)
            arising from your content, your use of the service, or your breach of these
            Terms or applicable law.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="h2">11) Termination</h2>
          <p>
            You may stop using ArtiBytes at any time. We may suspend or terminate access if
            you violate these Terms, the Content Policy, or law, or for security/compliance
            reasons. Provisions that by their nature should survive (e.g., IP ownership,
            disclaimers, limitations, indemnity, governing law) do survive termination.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="h2">12) Changes</h2>
          <p>
            We may modify these Terms. We’ll post updates in-app and adjust the Effective
            Date. Material changes will be notified in-app (and by email where available).
            Continued use after changes means you accept the updated Terms.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="h2">13) Governing Law &amp; Dispute Resolution</h2>
          <p>
            These Terms are governed by the laws of Estonia without regard to
            conflict-of-law rules. Courts located in Estonia will have exclusive
            jurisdiction.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="h2">14) Contact</h2>
          <p>
            Questions or concerns:{" "}
            <a href="mailto:jaytayeldev@gmail.com">jaytayeldev@gmail.com</a>
          </p>
        </section>
      </div>
    </Screen>
  );
}

/* ------------------------------ Styles ------------------------------ */
function StyleTag() {
  return (
    <style>{`
.legal-wrap{
  max-width: 860px;
  margin: 0 auto;
}
.legal-header .entity,
.legal-header .intro{
  color: #6B7280;
}
.legal-header .intro a{
  color: #6D5EF9; text-decoration: none; font-weight: 700;
}
.legal-header .intro a:hover{ text-decoration: underline; }
.legal-section{ margin-top: 18px; }
.legal-section p{ margin: 8px 0; line-height: 1.6; }
.legal-section ul{ margin: 8px 0 0 20px; display: grid; gap: 6px; }
    `}</style>
  );
}
